export const MOMENT_API_DATE_FORMAT = 'YYYY-MM-DD';
export const MOMENT_API_DATE_TIME_FORMAT = 'YYYY-MM-DD HH:mm:ss'
export const MOMENT_API_DATETIME_FORMAT = 'YYYY-MM-DD HH:mm';


// LOCAL SETTINGS
/*export const APIHOST  = 'http://localedi.faktura.uz';
export const AccountFakturaHostUrl = 'http://testaccount.faktura.uz';
export const AccountFakturaClientId = 'FakturaEDISystem';
export const SYSTEM_TERMS_FAILED_REDIRECT_URL = 'http://test.faktura.uz/ru/redirect/edi';
export const EIMZO_URL = 'ws://127.0.0.1:64646/service/cryptapi';
export const EIMZO_HOST = 'localhost';
export const EIMZO_API_KEY = '96D0C1491615C82B9A54D9989779DF825B690748224C2B04F500F370D51827CE2644D8D4A82C18184D73AB8530BB8ED537269603F61DB0D03D2104ABF789970B';
export const KORZINKA_INN = '302563857';
export const APP_FAKTURA_URL = 'http://test.faktura.uz';
export const APP_FAKTURA_LOGOUT_URL = 'http://testaccount.faktura.uz/logout';
export const INSTRUCTIONS_URL = '/Instructions_ru_2020_02_07.pdf';
export const INSTRUCTIONS_UZ_URL = '/Instructions_uz_2020_02_07.pdf';
export const APP_BILLING_PACKAGES_PATH = 'http://test.faktura.uz/ru/servicepackage/index';
export const APP_BILLING_PAYMENT_TEMPLATE_PATH = 'http://files.faktura.uz/Obrazec_plateshnogo_porucheniya.xls'
export const NotificationServiceSettings = {
    Host: "http://localhost:8001",
    TelegramBotUrl: "https://t.me/FakturaEdiTestBot"
}
export const ContractServiceSettings = {
    Host: "http://localhost:8102",
}*/

// TEST SERVER SETTINGS
/*export const APIHOST  = 'https://stagingedi.faktura.uz';
export const AccountFakturaHostUrl = 'https://stagingaccount.faktura.uz';
export const AccountFakturaClientId = 'FakturaEDISystem';
export const SYSTEM_TERMS_FAILED_REDIRECT_URL = 'https://stagingapp.faktura.uz/ru/redirect/edi';
export const EIMZO_URL = 'wss://127.0.0.1:64443/service/cryptapi';
export const EIMZO_HOST = 'localhost';
export const EIMZO_API_KEY = '96D0C1491615C82B9A54D9989779DF825B690748224C2B04F500F370D51827CE2644D8D4A82C18184D73AB8530BB8ED537269603F61DB0D03D2104ABF789970B';
export const KORZINKA_INN = '489043363';
export const APP_FAKTURA_URL = 'https://stagingapp.faktura.uz';
export const APP_FAKTURA_LOGOUT_URL = 'https://stagingapp.faktura.uz/account/logout';
export const INSTRUCTIONS_URL = '/Instructions_ru_2020_02_07.pdf';
export const INSTRUCTIONS_UZ_URL = '/Instructions_uz_2020_02_07.pdf';
export const APP_BILLING_PACKAGES_PATH = 'http://stagingapp.faktura.uz/ru/servicepackage/index';
export const APP_BILLING_PAYMENT_TEMPLATE_PATH = 'http://files.faktura.uz/Obrazec_plateshnogo_porucheniya.xls'
export const NotificationServiceSettings = {
    Host: "https://notificationedi.faktura.uz",
    TelegramBotUrl: "https://t.me/FakturaEDI_Bot"
}
export const ContractServiceSettings = {
    Host: "https://stagingedicontract.faktura.uz",
}*/


// LIVE SERVER SETTINGS
export const APIHOST  = '';
export const AccountFakturaHostUrl = 'https://account.faktura.uz';
export const AccountFakturaClientId = 'FakturaEDISystem';
export const SYSTEM_TERMS_FAILED_REDIRECT_URL = 'https://app.faktura.uz/ru/redirect/edi';
export const EIMZO_URL = 'wss://127.0.0.1:64443/service/cryptapi';
export const EIMZO_HOST = 'edi.faktura.uz';
export const EIMZO_API_KEY = 'F584DDDBF4B3974962916BC3D91891F797A7E6F653A99A83832D6E186DCCDAAB5277DFA2276D76A0C48E4D2D895F089A7F07A3C9901F6C266DD2A1107DB34E6B';
export const KORZINKA_INN = '202099756';
export const APP_FAKTURA_URL = 'https://app.faktura.uz';
export const APP_FAKTURA_LOGOUT_URL = 'https://app.faktura.uz/ru/account/logout';
export const INSTRUCTIONS_URL = '/Instructions_ru_2020_02_07.pdf';
export const INSTRUCTIONS_UZ_URL = '/Instructions_uz_2020_02_07.pdf';
export const APP_BILLING_PACKAGES_PATH = 'https://app.faktura.uz/servicepackage/index';
export const APP_BILLING_PAYMENT_TEMPLATE_PATH = 'http://files.faktura.uz/Obrazec_plateshnogo_porucheniya.xls'
export const NotificationServiceSettings = {
    Host: "https://notificationedi.faktura.uz",
    TelegramBotUrl: "https://t.me/FakturaEDI_Bot"
}
export const ContractServiceSettings = {
    Host: "https://contractedi.faktura.uz",
}
